import React from "react";
import HeroText from "../HeroText";

const Home = () => {
  return <HeroText />;
};

export default Home;
